/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation
import acharyamulLogo from "./assets/images/acharyamul.svg";
import eventrixLogo from "./assets/images/eventrix.svg";

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Kushagra Acharya",
  title: "Hi all, I'm Kushagra",
  subTitle: emoji(
    "AI / Software Engineer specialising in mobile application development and AI/ML integrations. Currently building RAG pipelines and knowledge graphs at Jaimee.ai while pursuing a Master's in ICT."
  ),
  resumeLink:
    "https://rxresu.me/k.acharya1107/kushagra", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/codeaskush",
  linkedin: "https://www.linkedin.com/in/kushagraacharya/",
  gmail: "k.acharya1107@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "MOBILE & AI ENGINEER WHO SHIPS PRODUCTS END-TO-END, FROM NATIVE APPS TO KNOWLEDGE GRAPHS",
  skills: [
    emoji(
      "⚡ Architect production RAG pipelines on PostgreSQL pgvector with LangChain, OpenAI and Anthropic LLMs"
    ),
    emoji("⚡ Ship native Android and iOS fintech applications with Kotlin, Swift and Flutter"),
    emoji(
      "⚡ Design and operationalise CI/CD pipelines with Jenkins, Fastlane and Docker across Linux fleets"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    // All icons render in their default brand colour.
    // iconSlug → simple-icons CDN. iconUrl → any full URL (used for icons missing from simple-icons).
    // ── AI / ML stack ──
    // LangChain / OpenAI / Anthropic force white in dark mode (default brand is black/invisible).
    {skillName: "LangChain", iconSlug: "langchain", darkColor: "ffffff"},
    {
      skillName: "OpenAI",
      iconUrl: "https://api.iconify.design/simple-icons:openai.svg?color=%23{color}",
      darkColor: "ffffff",
      lightColor: "000000"
    },
    {skillName: "Anthropic", iconSlug: "anthropic", darkColor: "ffffff"},
    {skillName: "Neo4j", iconSlug: "neo4j"},
    // ── Languages ──
    {skillName: "Python", iconSlug: "python"},
    {skillName: "JavaScript", iconSlug: "javascript"},
    {
      skillName: "Java",
      iconUrl: "https://api.iconify.design/logos:java.svg"
    },
    {skillName: "Kotlin", iconSlug: "kotlin"},
    {skillName: "Swift", iconSlug: "swift"},
    // ── Frameworks & DBs ──
    {skillName: "Node.js", iconSlug: "nodedotjs"},
    {skillName: "FastAPI", iconSlug: "fastapi"},
    {skillName: "React", iconSlug: "react"},
    {skillName: "Flutter", iconSlug: "flutter"},
    {skillName: "PostgreSQL", iconSlug: "postgresql"},
    {skillName: "Redis", iconSlug: "redis"},
    // ── DevOps & Cloud ──
    {skillName: "Docker", iconSlug: "docker"},
    {skillName: "Jenkins", iconSlug: "jenkins"},
    {skillName: "Linux", iconSlug: "linux"},
    {skillName: "Git", iconSlug: "git"},
    {
      skillName: "AWS",
      iconUrl: "https://api.iconify.design/logos:aws.svg"
    },
    {skillName: "Firebase", iconSlug: "firebase"}
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of the Sunshine Coast",
      logo: require("./assets/images/unisc1.jpg"),
      subHeader: "Master of Information and Communications Technology",
      duration: "2024 - Present",
      desc: "Currently undertaking Internship project with JaimeeAI",
      descBullets: [
        "Capstone: Jaimee long-term-memory layter (FastAPI + Celery + Redis + Neo4j with Graph Data Science)",
        "Completed Units: Programming, Databases, Cryptography, Cybersecurity, ICT Project Management"
      ]
    },
    {
      schoolName: "Everest Engineering College",
      logo: require("./assets/images/eemc.jpeg"),
      subHeader: "Bachelor of Computer Engineering",
      duration: "2014-2019 | GPA 3.15/4.00",
      desc: "Foundations in algoriths, operating systems, object oriented software design and networking.",
    }
  ]
};


// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Backend / AI Engineering Intern",
      company: "Jaimee AI",
      companylogo: require("./assets/images/jaimee.jpeg"), // TODO: replace with jaimeeLogo.png
      date: "2026 – Present",
      desc: "Sydney, NSW. Building a production RAG pipeline and Zep knowledge-graph ontology serving 5,000+ daily AI queries."
    },
    {
      role: "Integration Lead & Mobile App Lead",
      company: "OnePoint",
      companylogo: require("./assets/images/onepoint.jpeg"), // TODO: replace with onepointLogo.png
      date: "December 2023 – July 2024",
      desc: "Kathmandu, Nepal. Led a 4-dev mobile team and rebuilt CI/CD on Jenkins + Fastlane, cutting fintech release cycles by ~40%."
    },
    {
      role: "Software Engineer",
      company: "Zero Logic Space",
      companylogo: require("./assets/images/zls.jpeg"), // TODO: replace with zerologicLogo.png
      date: "August 2022 – February 2023",
      desc: "Lalitpur, Nepal. Designed 50+ REST endpoints and shipped the native Android client for a multi-tenant dental booking platform used by 8+ clinics."
    },
    {
      role: "Native Mobile Application Engineer",
      company: "Nepal Payment Solution",
      companylogo: require("./assets/images/nps.png"), // TODO: replace with npsLogo.png
      date: "2020 – 2022",
      desc: "Kathmandu, Nepal. Shipped 6 fintech apps to 50,000+ users and a POS Android terminal deployed across 300+ merchant devices."
    },
    {
      role: "Android Developer",
      company: "Prabhu Technology",
      companylogo: require("./assets/images/prabhu.jpeg"), // TODO: replace with prabhuLogo.png
      date: "2019 – 2020",
      desc: "Kathmandu, Nepal. Built native Android apps and 2 reusable in-house SDKs that cut third-party onboarding effort by ~60%."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Featured projects — three discipline-relevant samples covering AI/ML, full-stack, and SaaS.

const bigProjects = {
  title: "Featured Projects",
  subtitle:
    "Three projects spanning AI memory systems, full-stack heritage platforms, and event-management SaaS.",
  projects: [
    {
      image: require("./assets/images/jaimee.jpeg"),
      projectName: "Jaimee: Long-Term-Memory POC",
      projectDesc:
        "UniSC SCI700 capstone. A Neo4j-backed long-term-memory layer for an AI companion, built on FastAPI + Celery + Redis with a Vite/React dashboard. Combines Zep knowledge-graph ontology with a LangChain RAG pipeline over pgvector, integrating OpenAI and Anthropic LLMs. Planned through 54 functional requirements, 31 non-functional, 8 epics and 60 stories before implementation.",
      footerLink: [
        {name: "Learn More", url: "/projects/jaimee"}
      ]
    },
    {
      image: acharyamulLogo,
      projectName: "Acharyamul (Rootslegx)",
      projectDesc:
        "A collaborative bilingual (English / Devanagari) family-tree web application for the Acharya family of Tanahun, Nepal. Vertical (React Flow) and horizontal (D3.js) chart views, person & relationship management, contributor workflows, admin panel, Nepali kinship calculator, Google SSO, automated daily backups, deployed via Docker Compose + Nginx. Built with React 19, FastAPI, SQLAlchemy 2.0, PostgreSQL 16.",
      footerLink: [
        {name: "Visit Live Site", url: "https://acharyamul.kushagra.com.np"},
        {name: "Learn More", url: "/projects/acharyamul"}
      ]
    },
    {
      image: eventrixLogo,
      projectName: "Eventrix",
      projectDesc:
        "End-to-end event management SaaS covering digital ticketing, venue & seat-map management, terminal and device control, marketing CRM, and real-time attendance reporting. Built with React + NestJS + PostgreSQL with role-based access control and multi-tenant isolation. Designed UI/UX from scratch, owned API design and deployment.",
      footerLink: [
        {name: "Live Demo", url: "https://demo-operator.eventrix.cc"},
        {name: "Learn More", url: "/projects/eventrix"}
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certifications 🏆 "),
  subtitle: "",

  achievementsCards: [
    {
      title: "Azure AI Fundamentals (AI-900)",
      subtitle: "Microsoft · Issued March 2025",
      image: require("./assets/images/azure-ai.png"), // TODO: replace with azureAILogo.png (Credly badge)
      imageAlt: "Microsoft Azure AI Fundamentals badge",
      footerLink: [
        {
          name: "Verify on Credly",
          url: "https://www.credly.com/badges/d6aaf676-62ca-4a5e-a634-ce44e3824b57/linked_in_profile"
        }
      ]
    },
    {
      title: "Azure Data Fundamentals (DP-900)",
      subtitle: "Microsoft · Issued March 2025",
      image: require("./assets/images/azure-data.png"), // TODO: replace with azureDataLogo.png (Credly badge)
      imageAlt: "Microsoft Azure Data Fundamentals badge",
      footerLink: [
        {
          name: "Verify on Credly",
          url: "https://www.credly.com/badges/416624db-55b0-496f-8c4f-0e7fb784cfe9/linked_in_profile"
        }
      ]
    },
    {
      title: "Power Platform Fundamentals (PL-900)",
      subtitle: "Microsoft · Issued August 2024",
      image: require("./assets/images/power.png"), // TODO: replace with powerPlatformLogo.png (Credly badge)
      imageAlt: "Microsoft Power Platform Fundamentals badge",
      footerLink: [
        {
          name: "Verify on Credly",
          url: "https://www.credly.com/badges/3ea43711-1d77-4088-ad80-a5348c720ecc/linked_in_profile"
        }
      ]
    },
    {
      title: "IT Specialist - Python",
      subtitle: "Certiport · Issued October 2024",
      image: require("./assets/images/itpython.png"), // TODO: replace with itSpecialistPythonLogo.png (Credly badge)
      imageAlt: "Certiport IT Specialist Python badge",
      footerLink: [
        {
          name: "Verify on Credly",
          url: "https://www.credly.com/badges/4ed5a7a4-e291-49f3-b1cc-423bfd052c86/linked_in_profile"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Open to AI, backend, mobile and full-stack engineering roles in Sunshine Coast or remote. Happy to talk shop, share a coffee, or hear about your project.",
  number: "+61 425 171 095",
  email_address: "k.acharya1107@gmail.com",
  // Used as the static bio on the GitHub profile card (replaces the bio fetched from GitHub).
  bio: "AI / Software Engineer · Mobile + RAG + Knowledge Graphs · Currently at Jaimee.ai",
  location: "Sippy Downs, Queensland"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
